<script setup lang="ts">
import HelpGeoCoverageBase from '@/views/HelpGeoCoverageBase.vue'

const stats = [
  { value: '61', label: 'Countries' },
  { value: '27', label: 'European Union' },
  { value: '34', label: 'Outside EU' },
  { value: '10', label: 'Platforms' },
]
</script>

<template>
  <HelpGeoCoverageBase
    title="Reach & impression capture"
    subtitle="Countries where Ginjer captures reach or impression data, by paid-media platform — across the European Union and key markets outside the EU."
    :stats="stats"
    csv-url="/help/data/reach-coverage.csv"
    other-page-url="/help/unique-coverage"
    other-page-label="View unique ads coverage →"
    back-url="/help/platform-coverage"
    back-label="Back to Platform Coverage"
    last-updated="June 2026"
  />
</template>
